import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import AppSpinner from '../app-spinner';

const PageLoader = () => {
  return <AppSpinner />;
};

const mapDispatchToProps = (dispatch: any) => ({
});

export default compose(connect(null, mapDispatchToProps)(PageLoader));
